import backend from "@/api/backend";

const endpoint = '/orders'

export default {
    get(cursor=null, first=10) {
        return backend.get(
            endpoint,
            {params:
                    {cursor, first}
            }
            ).then(response => response.data)
    },
    async getOrderItems(orderId) {
        let hasNextPage = true
        let cursor = null
        let items = []
        while (hasNextPage) {
            const response = await backend.get(
                `${endpoint}/items`,
                {
                    params: { cursor, orderId }
                }
            )
            items = items.concat(response.data.order.lineItems.edges)
            hasNextPage = response.data.order.lineItems.pageInfo.hasNextPage
            break
        }
        return items
    }
}